import { useMemo } from 'react';
import { useAuth0 } from '../auth/useAuth';
import { getApiClient } from '../services/api';

/**
 * Returns a memoised axios client configured with the current Auth0 token.
 */
export default function useApi() {
  const { getAccessTokenSilently } = useAuth0();
  return useMemo(() => getApiClient(getAccessTokenSilently), [getAccessTokenSilently]);
}
